// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16srD","productName":"Table_productName__3Inms"};